export interface TableColumn {
  key: string;
  label: string;
  description?: string;
  sortable?: boolean;
  width?: string;
}

export const AVAILABLE_COLUMNS: TableColumn[] = [
  { key: 'name', label: 'Name', sortable: true, width: 'w-48' },
  { key: 'type', label: 'Type', sortable: true, width: 'w-32' },
  { key: 'site', label: 'Site', sortable: true, width: 'w-40' },
  { key: 'domain', label: 'Domain', sortable: true, width: 'w-32' },
  { key: 'purdue', label: 'Purdue Level', sortable: true, width: 'w-32' },
  { key: 'category', label: 'Category', sortable: true, width: 'w-40' },
  { key: 'owner', label: 'Owner', sortable: true, width: 'w-40' },
  { key: 'criticality', label: 'Criticality', sortable: true, width: 'w-32' },
  { key: 'risks', label: 'Risks', description: 'Open risks count', width: 'w-24' },
  { key: 'tasks', label: 'Tasks', description: 'Due/overdue tasks', width: 'w-24' },
  { key: 'evidence', label: 'Evidence', description: 'Evidence count', width: 'w-24' },
  { key: 'provider', label: 'Provider', sortable: true, width: 'w-32' },
  { key: 'environment', label: 'Environment', sortable: true, width: 'w-32' },
  { key: 'region', label: 'Region', sortable: true, width: 'w-32' },
  { key: 'site_code', label: 'Site Code', sortable: true, width: 'w-32' },
  { key: 'address', label: 'Address', sortable: true, width: 'w-48' },
  { key: 'country', label: 'Country', sortable: true, width: 'w-32' },
  { key: 'created_at', label: 'Created', sortable: true, width: 'w-32' },
  { key: 'updated_at', label: 'Updated', sortable: true, width: 'w-32' },
];

export const COLUMN_PRESETS = {
  containers: ['name', 'type', 'provider', 'environment', 'region', 'site_code', 'criticality', 'risks', 'tasks'],
  minimal: ['name', 'type', 'site'],
  standard: ['name', 'site', 'domain', 'type', 'tasks', 'risks'],
  detailed: ['name', 'type', 'site', 'domain', 'purdue', 'owner', 'criticality', 'tasks', 'risks', 'evidence'],
  all: AVAILABLE_COLUMNS.map(col => col.key),
};

export const DEFAULT_COLUMNS = COLUMN_PRESETS.standard;
